import * as React from "react";
import star from "../../asset/Star.png";

const Button = React.forwardRef(({ className = "", onClick, children, ...props }, ref) => {
  const baseClasses = "bg-gradient-to-r from-[#966376] via-[#CE92A8] to-[#cca1b181] py-4 inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-normal ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50";
  
  return (
    <button
      className={`${baseClasses} ${className}`}
      onClick={onClick}
      ref={ref}
      {...props}
    >
      <img className="h-[10px] w-[10px]" src={star} alt="star" />
      {children}
    </button>
  );
});

Button.displayName = "Button";

export { Button };
